import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Collapse from '@mui/material/Collapse';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import IconButton from '@mui/material/IconButton';
import CardMedia from '@mui/material/CardMedia';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? 'rotate(0deg)' : 'rotate(180deg)',
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
}));

function ExpDescList(props) {
  const descriptions = props.desc.map((d, index) => {
    return (
      <ListItem
        key={index}
      >
        <Typography
          variant='cardContentDesc'
          color="customText.white"
        >
          • {d}
        </Typography>
      </ListItem>
    );
  })

  return (
    <List>
      {descriptions}
    </List>
  )
}


function ExperienceWebsiteLink(props) {
  return (
    <Chip
      component={Link}
      sx={{
        typography: {
          fontWeight: 'bold',
          xl: {
            fontSize: '1.05rem'
          }
        },
        bgcolor: "customText.redOrange",
        color: "customText.white"
      }}
      href={props.website['url']}
      label={props.website['alias']}
      target="_blank"
      clickable
    >
    </Chip>
  )
}

export default function ExperienceCard(props) {
  const [expanded, setExpanded] = React.useState(false);

  const { experience } = props;

  const shouldRenderWebsite = experience.website !== undefined;

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card sx={{ bgcolor: "primary.main" }}>
      <CardHeader
        title={experience.company}
        subheader={experience.period}
        titleTypographyProps={{ variant: 'cardHeaderTitle', color: 'customText.blue' }}
        subheaderTypographyProps={{ variant: 'subtitle1', color: 'customText.lightGrey' }}
        color="customText.white"
      />
      <CardMedia
        component="img"
        height="194"
        image={experience.mediaPath}
      />
      <CardContent>
        <Typography
          variant='cardContentTitle'
          component="div"
          sx={{
            mt: 1.2,
            mb: 1.2,
          }}
          color="customText.orange"
        >
          {experience.title}
        </Typography>
        <Typography
          sx={{
            textAlign: "justify"
          }}
          variant="cardContentDesc"
          color="customText.lightGrey2">
          {experience.mainDescription}
        </Typography>
      </CardContent>
      <CardActions>
        <Box>
          {shouldRenderWebsite ? <ExperienceWebsiteLink website={experience.website}></ExperienceWebsiteLink> : null}
        </Box>
        <ExpandMore
          expand={expanded}
          onClick={handleExpandClick}
          aria-expanded={expanded}
          aria-label="show more"
        >
          <ExpandMoreIcon
            sx={{ color: "customText.lightGrey2" }}
          />
        </ExpandMore>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <ExpDescList desc={experience.description}></ExpDescList>
      </Collapse>
    </Card>
  );
}
